import { Trans } from "@similarweb/i18n-provider";

import ErrorBanner from "../../../../components/wizard/ErrorBanner/ErrorBanner";

import { StyledStrongText } from "./styles";

type Props = {
    errorMessage?: string;
};

const SfConfigurationErrorBanner = ({ errorMessage }: Props) => {
    return (
        <ErrorBanner>
            <Trans
                i18nKey="si.crm-enrichment.sf.wizard.error.configuration"
                components={{ bold: <StyledStrongText /> }}
                values={{ errorMessage }}
            />
        </ErrorBanner>
    );
};

export default SfConfigurationErrorBanner;
